export default __webpack_public_path__ + "static/media/AdobeStock_216036418.bca1db61.jpg";